import * as React from 'react';

const SvgSync = (props) => (
  <svg width={43} height={43} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <ellipse cx={21.497} cy={21.284} rx={21.497} ry={20.753} fill="url(#sync_svg__a)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.06 29.848c.576 0 1.06-.484 1.06-1.06v-1.636A10.003 10.003 0 0 0 21 31c5.023 0 9.286-3.756 9.908-8.756l.069-.507h-2.12l-.046.392c-.576 3.848-3.917 6.751-7.811 6.751-2.765 0-5.346-1.497-6.774-3.848h2.65c.576 0 1.06-.483 1.06-1.06 0-.576-.484-1.06-1.06-1.06h-4.84c-.506 0-1.036.323-1.036 1.06v4.816c0 .576.484 1.06 1.06 1.06Zm1.083-9.585.046-.392c.576-3.848 3.917-6.751 7.811-6.751 2.765 0 5.346 1.498 6.774 3.848h-2.627c-.576 0-1.06.484-1.06 1.06 0 .576.484 1.06 1.06 1.06h4.793c.438-.023 1.06-.3 1.06-1.06v-4.816c0-.576-.484-1.06-1.06-1.06-.576 0-1.06.484-1.06 1.06v1.636A10.003 10.003 0 0 0 21 11c-5.023 0-9.286 3.756-9.908 8.756l-.069.507h2.12Z"
      fill="#141414"
    />
    <defs>
      <linearGradient
        id="sync_svg__a"
        x1={21.497}
        y1={0.531}
        x2={21.497}
        y2={42.037}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#FF7C44" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgSync;
